var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-container",attrs:{"id":"page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"introduction-container__logo",attrs:{"src":"https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/logo.svg"}}),_vm._v(" "),_c('router-view')],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c39d4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroductionContainer/IntroductionContainer.vue
// module id = null
// module chunks = 